/**
 *  *   * this create member navigation sub nav effect
 *   *   **/
import $ from 'jquery';

export const memberNav = () => {
	
	// Dropdown toggle function
	$('.dropdown-toggle').click(function(){
  		$(this).next('.dropdown').slideToggle("fast");
	});
	// Hide dropdown on page click
	$(document).on('click', function (e) {
  		if(!$(".dropdown-toggle").is(e.target) && !$(".dropdown-toggle").has(e.target).length){
      			$('.dropdown').slideUp("fast");
  		} 
	});

}

